import EventBus from "eventing-bus"
import { constants, getCurrSection, setCurrSection } from "../model"

const viewEl = document.querySelector(".breadcrumb-nav-view"),
  itemsEl = viewEl.querySelectorAll("ul li")

const handleSectionChanged = () => {
  removeHandlers()

  if (getCurrSection() === 0 || getCurrSection() === 1) {
    changeNavFocus()
    setTimeout(() => {
      viewEl.classList.add("show")
      initHandlers()
    }, 3000)
  }
  if (getCurrSection() === 2) {
    changeNavFocus()
    setTimeout(() => {
      viewEl.classList.add("show")
      initHandlers()
    }, 3000)
  }
  if (getCurrSection() === 3) {
    viewEl.classList.remove("show")
  }
}

const handleClicked = (evt) => {
  const sectionNum = Number(evt.currentTarget.id)
  if (getCurrSection() !== sectionNum) setCurrSection(sectionNum)
}

const initHandlers = () => {
  for (let i = 0; i < itemsEl.length; i++) {
    itemsEl[i].addEventListener("click", handleClicked)
    itemsEl[i].id = i
  }
}

const removeHandlers = () => {
  for (let i = 0; i < itemsEl.length; i++) {
    itemsEl[i].removeEventListener("click", handleClicked)
  }
}

EventBus.on(constants.SECTION_CHANGED, handleSectionChanged)

const changeNavFocus = () => {
  for (let i = 0; i < itemsEl.length; i++) {
    itemsEl[i].classList.remove("active")
  }
  itemsEl[getCurrSection()].classList.add("active")
}
